import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { forkJoin, Subscription } from 'rxjs';
import { Classroom360Service } from '../../../classroom360/classroom360.service';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { CourseDescriptionDialogComponent } from '../../../shared-components/course-description-dialog/course-description-dialog.component';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { ProfileViewerDialogComponent } from '../../../shared-components/profile-viewer-dialog/profile-viewer-dialog.component';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { StudentService } from '../../../shared-components/student/student.service';
import { UserService } from '../../../shared-components/user/user.service';
import { SchoolYearSettings } from '../../../shared-components/year/school-year-settings.model';
import { YearService } from '../../../shared-components/year/year.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { LoginSettings } from '../../../shared-modules/login/loginSetting.model';
import { SendEmailService } from '../../../shared-modules/send-email/send-email.service';
import { Student360Service } from '../../student360.service';
import { AssignmentFilterParam } from '../assignment-filter-param';
import { AssignmentFilterPipe } from '../assignment-filter.pipe';
import { AssignmentsDTO } from '../assignment.model';
import { AssignmentService } from '../assignment.service';
import { StandardsBasedScoresComponent } from '../standards-based-scores/standards-based-scores.component';
import { Utility } from '../Utility';

@Component({
    selector: 'by-course',
    templateUrl: './by-course.component.html',
    styleUrls: ['./by-course.component.css'],
    animations: [detailExpand],
})
export class ByCourseComponent implements OnInit, OnDestroy {

    student360YearSubscription: Subscription;
    selectedStudentSubscription: Subscription;
    studentSchedules: CourseSchedule[];
    studentAssignments: AssignmentsDTO[] = [];
    studentAttachments: Attachment[] = [];
    courseInfo: AssignmentsDTO;
    subscriptions: Subscription[] = [];
    loginSettings: LoginSettings;
    selectedViewOption = 3;  // This Term
    selectedCourse: CourseSchedule;
    selectedGP: any = { Id: -1 };
    showStandardBasedScore = false;
    schoolYearSettings: SchoolYearSettings;
    local_filterParam = new AssignmentFilterParam();
    gradeDisplayType = '';
    constructing = true;
    canSendEmail = true;
    showCategoryWeights: boolean;

    public utilityClass = Utility;

    @Input() shown: boolean;
    @Output() schoolYearSettingsChange = new EventEmitter();
    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    columnsToDisplay: string[] = [];
    v9Columns: string[] = [];
    @Input() clearFilterEvent: EventEmitter<any>;

    // ------------Element references--------------------------------
    @ViewChild('divControls') divControls: ElementRef;
    @ViewChild('divCourseInfo') divCourseInfo: ElementRef;

    constructor(
        private student360Service: Student360Service,
        private classroom360Service: Classroom360Service,
        private studentService: StudentService,
        private yearService: YearService,
        private loginService: LoginService,
        private assignmentService: AssignmentService,
        private userService: UserService,
        private dialog: MatDialog,
        private assignmentFilterPipe: AssignmentFilterPipe,
        private router: Router,
        private sendEmailService: SendEmailService

    ) {
        this.loginSettings = this.loginService.LoginSettings;
        this.columnsToDisplay = ['More', 'DueDateDay', 'DueDate', 'AssignedDateDay', 'AssignedDate', 'Assignment', 'GradeBookUnit', 'Category', 'Possible', 'EarnedPoints', 'Percentage', 'SpecialMark', 'Effective', 'Grade'];

        this.canSendEmail = (this.userService.userType == 2 || this.userService.userType === 3) ? this.loginSettings.AllowParentStudentEmail : true;

        this.subscriptions.push(studentService.selectedStudentStream$.subscribe(studentId => {
            this.init();
        }));

        this.subscriptions.push(yearService.observableStudent360YearStream$.subscribe(student360Year => {
            this.init();
        }));

        this.subscriptions.push(this.assignmentService.filterChange.subscribe(() => {
            if (this.assignmentService.ShowByClass) {
                this.applyFilter();
            }
        }));

        if (this.userService.userType == 1) {
            this.subscriptions.push(this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(portals => {
                if (portals.filter(o => o.PortalName == 'Send Email' && o.Disabled == false && o.Deleted == false).length == 0) {
                    this.canSendEmail = false;
                }
            }));
        }
        else {
            this.subscriptions.push(this.student360Service.observableParentAssignedPortalsStream$.subscribe(portals => {
                if (portals.filter(o => o.PortalName == 'Send Email' && o.Disabled == false && o.Deleted == false).length == 0) {
                    this.canSendEmail = false;
                }
            }));
        }
    }

    ngOnInit() {
        this.assignmentService.studentAssignmentsUPMG = [];
        this.getSchoolYearSettings(false);
        if (this.clearFilterEvent) {
            this.subscriptions.push(
                this.clearFilterEvent.subscribe(() => {
                    if (this.shown) {
                        this.angularMatData.removeAllFilters();
                    }
                })
            );
        }
    }

    ngOnDestroy() {
        // POST: ends all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });

        this.assignmentService.filterbyCard = false;
    }

    loadFilterParam() {
        this.assignmentService.filterParam = this.local_filterParam;
    }

    course_change() {
        // if (this.assignmentService.selectedGP == null) {
        //     this.assignmentService.selectedCourse = this.selectedCourse;
        // }
        // this.assignmentService.selectedSectionId = this.selectedCourse.SiteSectionId;
        // this.assignmentService.studentAssignmentsUPMG = [];
        if (this.selectedCourse.CourseTerms.length > 0) {
            const schoolYearSettings: SchoolYearSettings = this.schoolYearSettings;
            const term = this.selectedCourse;
            let CourseTerms = [];
            CourseTerms = term.CourseTerms.filter(function (element) {
                return ((schoolYearSettings.UsingFinalGrade && element.ShortDescription.indexOf('Y') > -1)
                    || (schoolYearSettings.UsingSemesterGrades && element.ShortDescription.indexOf('S') > -1)
                    || (schoolYearSettings.UsingTermGrades && element.ShortDescription.indexOf('T') > -1)
                    || (schoolYearSettings.UsingProgressGrades && element.ShortDescription.indexOf('P') > -1));
            });
            this.selectedCourse.CourseTerms = Object.assign(CourseTerms);
        }
        this.selectTermByDates();
        this.gradingPeriod_Change();
    }

    gradingPeriod_Change() {
        // console.log(JSON.stringify(this.selectedGP_ID));
        if (this.selectedGP == -1) {
            this.courseInfo = null;
            this.angularMatData.data = [];
            this.studentAssignments = [];
            this.studentAttachments = [];
        }
        else if (this.selectedCourse != null) {
            this.angularMatData.data = [];
            setTimeout(() => {
                return forkJoin([this.assignmentService.getStudentAssignments(
                    this.studentService.selectedStudent.Id,
                    this.yearService.student360Year.Id,
                    this.selectedCourse.SiteSectionId,
                    this.selectedGP.StartDate,
                    this.selectedGP.EndDate,
                    this.selectedGP.Id,
                    this.studentService.studentEnrollment.SiteYearId
                ),
                this.assignmentService.getStudentAttachment(
                    this.studentService.selectedStudent.Id,
                    this.yearService.student360Year.Id,
                    this.selectedCourse.SiteSectionId,
                    this.selectedGP.StartDate,
                    this.selectedGP.EndDate,
                    this.selectedGP.Id,
                    this.studentService.studentEnrollment.SiteYearId
                )]).subscribe(results => {
                    if (results[0].length > 0) {
                        this.showStandardBasedScore = results[0].findIndex(x => x.ShowStandardBasedScore === true) >= 0;
                        this.courseInfo = results[0].filter(x => x.SystemGrade == true)[0];
                        this.showCategoryWeights = this.courseInfo.ShowCategoryWeights;
                        this.studentAssignments = results[0].filter(x => x.ShowOnPortal === true && x.SystemGrade === false);
                        this.studentAssignments.forEach(obj => {
                            obj.EarnedV9 = obj.Earned;
                            obj.EffectiveScoreV9 = obj.Effective;
                            obj.PercentageV9 = obj.Percentage;
                            if (this.utilityClass.IsValid(obj.Grade)) {
                                if (obj.Earned == 0) {
                                    obj.EarnedV9 = -1;
                                }
                                if (obj.Percentage == 0) {
                                    obj.PercentageV9 = -1;
                                }
                                if (obj.Effective == 0) {
                                    obj.EffectiveScoreV9 = -1;
                                }
                            } else {
                                if (obj.Earned == 0 && !this.utilityClass.IsValid(obj.Grade)) {
                                    obj.EarnedV9 = -2;
                                }
                                if (obj.Effective == 0 && !this.utilityClass.IsValid(obj.Grade)) {
                                    obj.EffectiveScoreV9 = -2;
                                }
                                if (obj.Percentage == 0 && !this.utilityClass.IsValid(obj.Grade)) {
                                    obj.PercentageV9 = -2;
                                }
                            }
                        });
                        this.applyFilter();
                        this.angularMatData.sortingDataAccessor = (item: AssignmentsDTO, property: string) => {
                            if (property == 'Assignment') {
                                return item.Assignment ? item.Assignment.toLowerCase() : '';
                            }
                            if (property == 'EarnedPoints') {
                                return item.EarnedV9;
                            } else if (property == 'Percentage') {
                                return item.PercentageV9;
                            } else if (property == 'Effective') {
                                return item.EffectiveScoreV9;
                            }
                            else {
                                return this.angularMatData.defaultSortingAccessor(item, property);
                            }
                        };
                        setTimeout(() => this.angularMatData.sort = this.sort, 0);
                    }
                    this.studentAttachments = results[1];
                });
            }, 700);
        }
    }

    init() {
        this.angularMatData.data = [];
        this.courseInfo = null;
        this.studentAssignments = [];
        this.studentAttachments = [];
        if (!this.constructing) {		// We only need to reset the variables after initial construction
            this.selectedCourse = null;
            this.selectedGP = { Id: -1 };
            this.assignmentService.selectedCourse = null;
            this.local_filterParam = new AssignmentFilterParam();
        } else {
            this.constructing = false;
        }
        if (this.assignmentService.selectedView != undefined) {
            this.selectedViewOption = this.assignmentService.selectedView;
        }

        this.loadStudentSchedules();
        this.getSchoolYearSettings(true);
    }

    loadStudentSchedules() {
        this.studentService.getStudentSchedule(
            this.studentService.selectedStudent.Id,
            this.yearService.student360Year.Id,
            this.selectedViewOption, undefined, undefined, undefined, undefined, undefined, undefined
        ).subscribe(data => {
            this.studentSchedules = data.filter(x => x.UsedForGrading === true);
            this.selectedCourse = this.studentSchedules.find(studentSchedule => (studentSchedule.SubjectCode + '-' + studentSchedule.Section) == this.assignmentService.selectedCourseSection);

            // **************** ONE-12288 *******************
            if (this.assignmentService.selectedGP != null) {
                if (this.assignmentService.filterbyCard == true && this.selectedCourse.CourseTerms != null) {
                    this.selectedGP = this.selectedCourse.CourseTerms.filter(o => o.LongDescription == this.assignmentService.selectedGP)[0];
                }
                else {
                    if (this.selectedCourse.CourseTerms != null) {
                        this.selectedGP = this.selectedCourse.CourseTerms.filter(o => o.ShortDescription == this.assignmentService.selectedGP)[0];
                    }
                }
                if (this.selectedGP == null) {
                    this.selectedGP = this.selectedCourse.CourseTerms[0];
                }
            }
            else if (this.assignmentService.selectedGP == undefined && this.assignmentService.selectedSectionId != undefined && this.assignmentService.filterbyCard == false) {
                this.selectTermByDates();
            }
            setTimeout(() => {
                this.gradingPeriod_Change();
            }, 500);

            // **************** ONE-12288 ************************

            if (this.selectedCourse) {	// We do this to ensure the references for the HTML selector are the sames

                if (this.assignmentService.filterbyCard == true) {
                    this.selectedCourse = this.studentSchedules.find(studentSchedule => (studentSchedule.SubjectCode + '-' + studentSchedule.Section) == this.assignmentService.selectedCourseSection);
                }
                else {
                    if (this.selectedCourse.SiteSectionId > 0) {
                        this.selectedCourse = this.studentSchedules.find(studentSchedule => studentSchedule.SiteSectionId == this.selectedCourse.SiteSectionId);
                        if (this.selectedCourse != null) {
                            if (this.selectedCourse.CourseTerms.length > 0) {
                                const schoolYearSettings: SchoolYearSettings = this.schoolYearSettings;
                                const term = this.selectedCourse;
                                let CourseTerms = [];
                                CourseTerms = term.CourseTerms.filter(function (element) {
                                    return ((schoolYearSettings.UsingFinalGrade && element.ShortDescription.indexOf('Y') > -1)
                                        || (schoolYearSettings.UsingSemesterGrades && element.ShortDescription.indexOf('S') > -1)
                                        || (schoolYearSettings.UsingTermGrades && element.ShortDescription.indexOf('T') > -1)
                                        || (schoolYearSettings.UsingProgressGrades && element.ShortDescription.indexOf('P') > -1));
                                });
                                this.selectedCourse.CourseTerms = Object.assign(CourseTerms);
                            }
                        }
                    }
                    else {
                        this.selectedCourse = this.studentSchedules.find(studentSchedule => studentSchedule.Course == this.selectedCourse.Course);
                    }
                }

                if (this.assignmentService.selectedGP != null) {
                    if (this.assignmentService.filterbyCard == true && this.selectedCourse.CourseTerms != null) {
                        this.selectedGP = this.selectedCourse.CourseTerms.filter(o => o.LongDescription == this.assignmentService.selectedGP)[0];
                    }
                    else {
                        if (this.selectedCourse.CourseTerms != null) {
                            this.selectedGP = this.selectedCourse.CourseTerms.filter(o => o.ShortDescription == this.assignmentService.selectedGP)[0];
                        }
                    }
                    if (this.selectedGP == null) {
                        this.selectedGP = this.selectedCourse.CourseTerms[0];
                    }
                }
                else if (this.assignmentService.selectedGP == undefined && this.assignmentService.selectedSectionId != undefined && this.assignmentService.filterbyCard == false) {
                    this.selectTermByDates();
                }
                this.assignmentService.selectedGP = null;
                if (this.assignmentService.filterbyCard == true) { this.course_change(); }
            }
            if (this.loginSettings.ParentPortalAssignmentsDisplayProfiles) {
                this.studentSchedules.forEach(s => s.Course = s.Course + '-' + s.Section);
            }
            else {
                this.studentSchedules.forEach(s => s.Course = s.Course + ' - ' + (s.Term === 'Year' ? 'Yr' : s.Term));
            }
        });
        this.assignmentService.selectedView = undefined;
    }

    getStudentAssignments(): void {
        this.angularMatData.data = [];

        setTimeout(() => {
            this.assignmentService.getStudentAssignments(
                this.studentService.selectedStudent.Id,
                this.yearService.student360Year.Id,
                this.selectedCourse.SiteSectionId,
                this.selectedGP.StartDate,
                this.selectedGP.EndDate,
                this.selectedGP.Id,
                this.studentService.studentEnrollment.SiteYearId
            ).subscribe(data => {
                if (data.length > 0) {
                    this.showStandardBasedScore = data.findIndex(x => x.ShowStandardBasedScore === true) >= 0;
                    this.courseInfo = data.filter(x => x.SystemGrade == true)[0];
                    this.studentAssignments = data.filter(x => x.ShowOnPortal === true && x.SystemGrade === false);
                    this.studentAssignments.forEach(x => {
                        if (this.utilityClass.IsValid(x.Comment)) {
                            x.Comment = x.Comment.replace('\n', '<br>');
                        }
                    });
                    this.applyFilter();
                    setTimeout(() => {
                        this.angularMatData.sort = this.sort;
                    }, 0);
                }
            });
        }, 0);
    }

    getStudentAttachments(): void {
        setTimeout(() => {
            this.assignmentService.getStudentAttachment(
                this.studentService.selectedStudent.Id,
                this.yearService.student360Year.Id,
                this.selectedCourse.SiteSectionId,
                this.selectedGP.StartDate,
                this.selectedGP.EndDate,
                this.selectedGP.Id,
                this.studentService.studentEnrollment.SiteYearId
            ).subscribe(data => this.studentAttachments = data);
        }, 0);
    }

    applyFilter() {
        if (this.assignmentService.filterParam) {
            this.local_filterParam = Object.assign(new AssignmentFilterParam(), this.assignmentService.filterParam);
            this.angularMatData.data = this.assignmentFilterPipe.transform(this.studentAssignments, this.assignmentService.filterParam);
        }
        else {
            this.angularMatData.data = this.studentAssignments;
        }

        setTimeout(() => this.angularMatData.sort = this.sort, 100);
    }

    // ------------Assignment Grid Methods ---------------------------
    selectTermByDates() {
        const currDate = new Date();
        if (this.selectedCourse != null && (!this.selectedGP || this.selectedGP.Id == -1)) {
            const filteredTerms = this.selectedCourse.CourseTerms.filter(x => currDate <= new Date(x.EndDate) && currDate >= new Date(x.StartDate));
            if (filteredTerms.length > 0) {
                const sortedTerms = _.orderBy(filteredTerms, ['EndDate', 'TermTypeId'], ['asc', 'desc']);
                this.selectedGP = sortedTerms[0];

                if (!this.selectedGP && this.selectedCourse.CourseTerms.length > 0) {
                    const lastIndex = this.selectedCourse.CourseTerms.length - 1;

                    if (currDate > new Date(this.selectedCourse.CourseTerms[lastIndex].EndDate)) {
                        this.selectedGP = this.selectedCourse.CourseTerms[lastIndex];
                    }
                    else {
                        this.selectedGP = this.selectedCourse.CourseTerms[0];
                    }
                }
            }
            else { // term is preselected
                if (this.selectedCourse.CourseTerms) {
                    let index = this.selectedCourse.CourseTerms.findIndex(x => x.MediumDescription === this.selectedGP.MediumDescription);
                    if (index >= 0) {
                        this.selectedGP = this.selectedCourse.CourseTerms[index];
                    }
                    else {
                        index = this.selectedCourse.CourseTerms.length - 1;
                        if (currDate > new Date(this.selectedCourse.CourseTerms[index].EndDate)) {
                            this.selectedGP = this.selectedCourse.CourseTerms[index];
                        }
                        else {
                            this.selectedGP = this.selectedCourse.CourseTerms[0];
                        }
                    }
                }
            }
        }
        else if (this.selectedCourse != null) { // term is preselected
            if (this.selectedCourse.CourseTerms) {
                let index = this.selectedCourse.CourseTerms.findIndex(x => x.MediumDescription === this.selectedGP.MediumDescription);
                if (index >= 0) {
                    this.selectedGP = this.selectedCourse.CourseTerms[index];
                }
                else {
                    index = this.selectedCourse.CourseTerms.length - 1;
                    if (currDate > new Date(this.selectedCourse.CourseTerms[index].EndDate)) {
                        this.selectedGP = this.selectedCourse.CourseTerms[index];
                    }
                    else {
                        this.selectedGP = this.selectedCourse.CourseTerms[0];
                    }
                }
            }
        }
    }

    showToggleIcon(row: AssignmentsDTO): boolean {
        let toggle = true;

        toggle = this.canSendEmail || (!!row.Comment) || (!!row.Summary) || (!!row.AttachmentDetail) || this.isAttachmentExists(row.AssignmentId) || (row.GradeBookObjectives ? row.GradeBookObjectives.length : 0) > 0;

        return toggle;
    }

    isAttachmentExists(assignmentId: number): boolean {
        return this.studentAttachments.findIndex(x => x.AssignmentId === assignmentId) >= 0;
    }

    getStudentAttachmentByAssignmentId(assignmentId: number): Attachment[] {
        return this.studentAttachments.filter(x => x.AssignmentId === assignmentId);
    }

    getSBSScore(sbs: any) {
        return (sbs.Score == -1 ? '' : sbs.Score);
    }

    getAssignmentStatus(status: number, dueDate: Date) {
        switch (status) {
            case 1:
                return 'Today ';
            case 3:
                return 'Missing ';
            case 5:
                return 'Tomorrow ';
            default:
                return formatDate(dueDate, 'E', 'en-us');
        }
    }

    // --------- Toggle Row ----------------------------

    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    // ------------ Popups --------------------------------

    courseDescription_click() {
        // PRE: the user clicks on a course description link under a course
        // POST: shows a modal for the course's description
        this.dialog.open(CourseDescriptionDialogComponent, {
            data: {
                course: this.selectedCourse.Course,
                courseSection: this.selectedCourse.SubjectCode + '-' + this.selectedCourse.Section,
                teacherName: this.selectedCourse.TeacherName,
                schoolName: this.selectedCourse.SchoolName,
                curriculum: this.selectedCourse.Curriculum,
                dDescription: this.selectedCourse.Description
            }
        });
    }

    classInformation_click() {
        // PRE: the user clicks on a class information link under a course
        // POST: shows a modal for that class' profile
        const dialogBox = this.dialog.open(ProfileViewerDialogComponent, {
            data: {
                courseSSEC_ID: this.selectedCourse.SiteSectionId,
                courseName: this.selectedCourse.Course,
                courseSection: this.selectedCourse.SubjectCode + '-' + this.selectedCourse.Section,
                teacherId: this.selectedCourse.TeacherMemId,
                teacherName: this.selectedCourse.TeacherName,
                school: this.selectedCourse.SchoolName,
                profiles: this.selectedCourse.CourseProfile,
                showTeacherProfileLink: this.selectedCourse.HasTeacherProfile
            }
        });
        this.subscriptions.push(
            dialogBox.componentInstance.teacherProfileClick.subscribe(() => {
                this.teacherProfile_click();
            })
        );
    }

    teacherProfile_click() {
        // PRE: the user clicks on a teacher profile link under a couse
        // POST: shows a modal for that teacher's profile
        this.dialog.open(ProfileViewerDialogComponent, {
            data: {
                teacherId: this.selectedCourse.TeacherMemId,
                profiles: this.selectedCourse.TeacherProfile,
                teacherName: this.selectedCourse.TeacherName,
                school: this.selectedCourse.SchoolName
            }
        });
    }

    ShowStandardBasedScore(teacherName) {
        const dialogBox = this.dialog.open(StandardsBasedScoresComponent, {
            panelClass: 'tyl-mat-dialog',
            width: '80vw',
            height: '85vh',
            disableClose: true,
            data: {
                teacherName: teacherName,
                course: this.selectedCourse,
                siteSectionId: this.selectedCourse.SiteSectionId,
                startDate: this.selectedGP.StartDate,
                endDate: this.selectedGP.EndDate,
                termId: this.selectedGP.Id,
                studentAssignments: this.studentAssignments
            },
        });
    }

    sendEmail() {
        this.sendEmailService.teacherName = this.courseInfo.TeacherName;
        this.sendEmailService.teacherEmailAddress = this.courseInfo.TeacherEmail;
        if (!this.userService.studentInformationView) {
            this.router.navigateByUrl('/student360/sendEmail');
        }
        else {
            this.userService.updateStudentViewRoute('/student360/sendEmail');
        }
    }

    // ------------Aria/Accessibility---------------------------
    getAriaRow(row: AssignmentsDTO): string {
        const colList: string[] = ['Due Date', 'Assigned Date', 'Assignment', 'Category', 'Possible Points', 'Earned Points', 'Percentage', 'Grade'];

        const dataList: string[] = [
            moment(row.DueDate).format('MM/dd/yy'),
            moment(row.AssignedDate).format('MM/dd/yy'),
            row.AssignmentShortName,
            row.Category,
            row.Possible.toString(),
            row.EarnedValue != null ? row.EarnedValue : '',
            row.PercentageValue != null ? row.PercentageValue : '',
            row.Grade
        ];
        return AriaDirective.concatAriaStrings(colList, dataList);
    }

    getSchoolYearSettings(fromInitMethod: boolean) {
        this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.studentService.studentEnrollment.SchoolId).subscribe(data => {
            this.schoolYearSettings = data;
            this.schoolYearSettingsChange.emit(this.schoolYearSettings);

            if (!fromInitMethod) {
                if (this.assignmentService.selectedCourse != null && this.assignmentService.selectedCourse != undefined) {
                    this.selectedCourse = _.cloneDeep(this.assignmentService.selectedCourse);
                    if (this.assignmentService.filterbyCard == true) {
                        this.loadStudentSchedules();
                    }
                    this.assignmentService.selectedCourse = null;
                    if (this.assignmentService.filterbyCard == false) {
                        if (this.studentSchedules && this.studentSchedules.length > 0) {	// We do this to ensure the references for the HTML selector are the same
                            this.selectedCourse = this.studentSchedules.find(studentSchedule => studentSchedule.Id == this.selectedCourse.Id);
                        }
                        if (this.assignmentService.selectedGP != null) {
                            this.selectedGP = this.selectedCourse.CourseTerms.filter(o => o.ShortDescription == this.assignmentService.selectedGP)[0];
                            if (this.selectedGP == null) {
                                this.selectedGP = this.selectedCourse.CourseTerms[0];
                            }
                        }
                        this.course_change();
                    }
                }
            }

            this.columnsToDisplay = ['More', 'DueDateDay', 'DueDate', 'AssignedDateDay', 'AssignedDate', 'Assignment', 'GradeBookUnit', 'Category', 'Possible', 'EarnedPoints', 'Percentage', 'SpecialMark', 'Effective', 'Grade'];
            if (this.schoolYearSettings.HideS360AssignmentPercentageColumn) {
                this.columnsToDisplay = this.columnsToDisplay.filter(o => o != 'Percentage');
            }
            if (this.schoolYearSettings.HideS360AssignmentEffectiveScoreColumn) {
                this.columnsToDisplay = this.columnsToDisplay.filter(o => o != 'Effective');
            }
        });
    }
}
